import React from 'react';
import { FileIconBase } from './_base';
const DocFileIcon = (props) => (React.createElement(FileIconBase, Object.assign({}, props, { defaultColor: "#2B7CD3", label: "DOC" })));
export default DocFileIcon;
